export default __webpack_public_path__ + "static/media/basket_active.79f6b4cd.svg";